import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useParams } from "react-router-dom";

import MinimalPage from "../../layout/MinimalPage";
import api from "../../service/api";
import DatosGrupo from "./DatosGrupo";
import ListadoOrganismos from "./ListadoOrganismos";
import Loader from "../../components/Loader";

const breadcrumbs = [
  { nombre: "Inicio", ruta: "/" },
  { nombre: "Consulta de grupos", ruta: "/grupos" },
  { nombre: "Gestión", ruta: "" },
];

const GestionarGrupoPage = ({ funcion }) => {
  const { grupoId } = useParams();
  const [grupo, setGrupo] = useState(null);
  const [organismos, setOrganismos] = useState(null);

  const obtener = async () => {
    try {
      const response = await api.obtenerGrupo({ id: grupoId });
      setGrupo(response.data);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.error || "Error!");
    }
  };

  const obtenerOrganismos = async () => {
    try {
      const response = await api.obtenerOrganismosGrupo({ id: grupoId });
      setOrganismos(response.data);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.error || "Error!");
    }
  };

  const agregar = async (datos) => {
    try {
      const response = await api.agregarOrganismoGrupo(datos);
      await obtenerOrganismos();
      return response.data;
      // return true;
    } catch (error) {
      throw new Error(error.response?.data?.error || "Error!");
    }
  };

  const marcarMesaEntrada = async (datos) => {
    try {
      const response = await api.marcarMesaEntrada(datos);
      await obtenerOrganismos();
      return response.data;
      // return true;
    } catch (error) {
      throw new Error(error.response?.data?.error || "Error!");
    }
  };

  const transferir = async (datos) => {
    try {
      const response = await api.transferirOrganismoGrupo(datos);
      await obtenerOrganismos();
      // return response.data;
      return true;
    } catch (error) {
      throw new Error(error.response?.data?.error || "Error!");
    }
  };

  useEffect(() => {
    setGrupo(null);
    setOrganismos(null);
    obtener();
    obtenerOrganismos();
  }, [grupoId]);

  return (
    <MinimalPage breadcrumbs={breadcrumbs}>
      {!(grupo && organismos) && <Loader />}
      {grupo && organismos && (
        <>
          <DatosGrupo grupo={grupo} />
          <ListadoOrganismos
            grupoId={grupoId}
            organismos={organismos}
            agregar={agregar}
            marcarMesaEntrada={marcarMesaEntrada}
            transferir={transferir}
          />
        </>
      )}
    </MinimalPage>
  );
};

export default GestionarGrupoPage;
